/*eslint-disable */
define(
    ['moment'],
    function(moment) {
        /**
         * Date functions.
         */
        var _self = {
            // MONDAY -> 1
            dayStringToNumberMap: {
                "SUNDAY"    : 0,
                "MONDAY"    : 1,
                "TUESDAY"   : 2,
                "WEDNESDAY" : 3,
                "THURSDAY"  : 4,
                "FRIDAY"    : 5,
                "SATURDAY"  : 6
            },
            // 1 -> MONDAY. Sunday is 0.
            dayNumberToStringMap: [
                "SUNDAY",
                "MONDAY",
                "TUESDAY",
                "WEDNESDAY",
                "THURSDAY",
                "FRIDAY",
                "SATURDAY"
            ],
            apiDateFormat: "yy-mm-dd",
            SECONDS_IN_DAY: 86400,
            SECONDS_IN_HOUR: 3600,
            /**
             * Parses the given date to a Date object.
             *
             * If format is {date}T{time}Z, returned date is converted from UTC to venue's local time
             * If format is {date}T{time}, returned date is in current venue's local time
             *
             * @param string str
             * @param boolean local If date is not UTC,
             * @return Date
             * @throws Error if string is invalid
             */
            parse: function(str) {
                var pattern = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([Z]?)/;
                var parts   = str.match(pattern);

                if (!parts) {
                    throw new Error('"' + str + '" does not look like a valid date');
                }

                if (parts[7] === "Z") {
                    // UTC time converted to Venue's date
                    return _self.createVenueDate(Date.UTC(
                        parseInt(parts[1], 10),
                        parseInt(parts[2], 10) - 1,
                        parseInt(parts[3], 10),
                        parseInt(parts[4], 10),
                        parseInt(parts[5], 10),
                        parseInt(parts[6], 10),
                        0
                    ));
                } else {
                    // Venue local time
                    return new Date(
                        parseInt(parts[1], 10),
                        parseInt(parts[2], 10) - 1,
                        parseInt(parts[3], 10),
                        parseInt(parts[4], 10),
                        parseInt(parts[5], 10),
                        parseInt(parts[6], 10),
                        0
                    );
                }

            },

            /**
             * Converts the given Date object to string accepted by the API.
             *
              * @param Date date
              * @return string
             */
            toApiString: function(date) {
                return date.getFullYear() + '-' + _self._makeDoubleDigit(date.getMonth() + 1) + '-' + _self._makeDoubleDigit(date.getDate());
            },

            /**
             * Creates a date in venue time zone.
             *
             * @param $_ Accepts all parameters, that the Date object accepts
             * @return Date
             */
            createVenueDate: function() {
                var date;

                switch (arguments.length) {
                    case 1:
                        date = new Date(arguments[0]);
                    break;

                    case 3:
                        date = new Date(arguments[0], arguments[1], arguments[2]);
                    break;

                    case 4:
                        date = new Date(arguments[0], arguments[1], arguments[2], arguments[3]);
                    break;

                    case 5:
                        date = new Date(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                    break;

                    case 6:
                        date = new Date(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                    break;

                    case 7:
                        date = new Date(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
                    break;

                    default:
                        date = new Date();
                }
                return _self._adjustDate(date, true);
            },

            /**
             * Adjusts the given date to the venue's time zone.
             *
             * @param Date date
             * @param boolean bOnClient
             * @return Date
             */
            _adjustDate: function(date, bOnClient) {
                return date;

                // TODO: adjusting the date according to venue time
                var d = new Date();
                var clientOffset = date.getTimezoneOffset();
                var adjust = App.config.get('venue').timeOffset + clientOffset;
                if (!bOnClient) {
                    adjust = - adjust;
                }
                return new Date(date.getTime() + adjust * 60000);
            },

            /**
             * Adds (or subtracts, if negative) given minutes from the given date.
             * @param Date date
             * @param int minutes
             *
             * @return Date The new date object
             */
            addMinutesToDate: function (date, minutes) {
                var dt = new Date(date.getTime() + minutes * 60000);
                return new Date(dt.getTime() + (dt.getTimezoneOffset() - date.getTimezoneOffset()) * 60000);
            },

            addDaysToDate: function (date, days) {
                // 1440 = minutes in day
                return _self.addMinutesToDate(date, days * 1440);
            },

            addMonthsToDate: function(date, months) {
                // TODO: this can add 1 extra month if the `date` day exceeds max days in the new month. E.g. Feb 31 -> Mar 2 or Mar 3.
                return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
            },

            /**
             * Formats the date (using moment).
             *
             * @param String format
             * @param Date date
             * @return String
             */
            formatDate: function(format, date) {
                return moment(date).format(format);
            },

            /**
             * Formats the date to format in jQuery Datepicker format.
             * @see self::formatDate and Wahanda.Time.toFormatted
             *
             * @param String dateFormat
             * @param string timeFormat
             * @param Date date
             * @return {date, time} - formatted object
             */
//			formatDateTime: function(dateFormat, timeFormat, date) {
//				var minutes = Wahanda.Time.getDateMinutes(date);
//				return {
//					date: _self.formatDate(dateFormat, date),
//					time: Wahanda.Time.toFormatted(minutes, timeFormat)
//				};
//			},

            /**
             * Formats to venue default time and date strings.
             *
             * @param string|Date date If string, must be in `parse` acceptable format
             * @see formatDateTime
             */
            formatToDefaultFullDate: function(date) {
                return _self.formatDateTime(
                    App.config.get('dateFormat').defaultDate,
                    App.config.get('dateFormat').defaultTime,
                    (typeof date === "string" ? _self.parse(date) : date)
                );
            },

            /**
             * Formats to venue default date string.
             *
             * @param string|Date date If string, must be in `parse` acceptable format
             * @see formatDate
             */
            formatToDefaultDate: function(date) {
                return _self.formatDate(
                    App.config.get('dateFormat').defaultDate,
                    (typeof date === "string" ? _self.parse(date) : date)
                );
            },

            /**
             * Formats Date object to API date and time format.
             *
             * @see formatToDefaultFullDate
             */
//			formatToApiFullDate: function(date) {
//				return _self.formatDateTime(
//					_self.apiDateFormat,
//					Wahanda.Time.apiTimeFormat,
//					(typeof date === "string" ? _self.parse(date) : date)
//				);
//				_self.apiDateFormat
//			},

            /**
             * Is the given date valid?
              *
              * @param Date date
              * @return boolean
             */
            isValidDate: function(date) {
                return date && date instanceof Date && !isNaN(date.getTime());
            },

            /**
             * @param String dateString
             * @return boolean
             */
            isValidApiDateString: function(dateString) {
                var pattern = /^(\d{4})-(\d{2})-(\d{2})$/;
                return pattern.test(dateString);
            },

            /**
             * Is the given date today?
             *
             * @param Date date
             * @return boolean
             */
            isToday: function(date) {
                var today = _self.createVenueDate();
                return _self.isEqualDates(date, today);
            },

            isEqualDates: function(date1, date2) {
                return date1.getYear() == date2.getYear()
                    && date1.getMonth() == date2.getMonth()
                    && date1.getDate() == date2.getDate();
            },

            /**
             * Is the given date inside of other two?
             *
             * @param Date date
             * @param Date from
             * @param Date to
             * @return boolean
             */
            isDateBetween: function(date, from, to) {
                var time = date.getTime();
                return time >= _self.getMidnight(from).getTime() && time <= _self.getMidnight(to).getTime();
            },

            /**
             * Returns the given date with time set to 00:00:00.
             * If no date is passed, current date is returned.
             *
             * @param Date date
             * @return Date
             */
            getMidnight: function(date) {
                if (!date) {
                    date = new Date;
                }
                return new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    0, 0, 0, 0
                );
            },

            /**
             * Gets days in month of the given Date object.
             *
             * @param Date date
             * @return int
             */
            getDaysInMonth: function(date) {
                return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
            },

            _makeDoubleDigit: function(value) {
                return (value < 10) ? "0" + value  : value;
            },

            /**
             * Do given date ranges overlap?
             *
             * @param Array range1 [from, to]
             * @param Array range2 [from, to]
             * @return boolean
             */
            doOverlap: function(range1, range2) {
                // (StartA <= EndB) and (EndA >= StartB)
                return (
                    range1[0].getTime() <= range2[1].getTime()
                    && range1[1].getTime() >= range2[0].getTime()
                );
            },

            /**
             * Creates date from string.
             *
             * @param String date yyyy-mm-dd
             * @param String time OPTIONAL HH:mm (default 00:00)
             * @param String fromUTC OPTIONAL Convert the time from UTC to Local venue time (default off)
             * @return Date
             */
            createDate: function(date, time, fromUTC) {
                time = (time || "00:00");
                return _self.parse(date + "T" + time + ":00" + (fromUTC ? "Z" : ""));
            },

            /**
             * Creates date from string, if the given param is string. Otherwise return what is given.
             *
             * @param String | Date date
             * @return Date
             */
            createDateIfString: function(date) {
                if (typeof date === "string") {
                    date = _self.createDate(date);
                }
                return date;
            },

            /**
             * Returns array of dates, having the same month as "monthDate", but days from "days" array.
             * @param Date monthDate
             * @param Array days Array of integers
             */
            getMonthDates: function(monthDate, days) {
                var year  = monthDate.getFullYear();
                var month = monthDate.getMonth();
                var dates = [];
                _.each(days, function(day) {
                    dates.push(new Date(year, month, day));
                });
                return dates;
            },

            getMonthDateApiStrings: function(monthDate, days) {
                var dates = _self.getMonthDates(monthDate, days);
                var strings = [];
                for (var i = 0, len = dates.length; i < len; i++) {
                    strings.push(_self.toApiString(dates[i]));
                }
                return strings;
            },

            /**
             * Returns date (ignoring the time) range information in contrast to currentDate.
             *
             * E.g. is the dated in the past, or currentDate in the middle, or everything will be in the future.
             *
             * @param Date from OPTIONAL
             * @param Date to OPTIONAL
             * @param Date currentDate OPTIONAL Defaults to current venue date
             *
             * @return Object {
             * 	  isFuture: boolean,
             *    isCurrent: boolean,
             *    isPast: boolean
             * }
             */
            compareRange: function(from, to, currentDate) {
                currentDate || (currentDate = _self._adjustDate(_self.createVenueDate()));

                var now  = _self.getMidnight(currentDate).getTime();
                from     = (from ? _self.getMidnight(from).getTime() : null);
                to       = (to ? _self.getMidnight(to).getTime() : null);

                var isFuture  = false;
                var isCurrent = false;
                var isPast    = false;

                if (from && from > now) {
                    isFuture = true;
                } else if (to && now > to) {
                    isPast = true;
                } else {
                    isCurrent = true;
                }

                return {
                    isFuture : isFuture,
                    isCurrent: isCurrent,
                    isPast   : isPast
                };
            },

            /**
             * Converts day enumerations (MONDAY, ...) array to corresponding integer (weekday number) array.
             *
             * @param Array list
             * @return Array
             */
            dayEnumsToNumbers: function(list) {
                var ret = [];
                for (var i = 0, len = list.length; i < len; i++) {
                    ret.push(
                        _self.dayStringToNumberMap[list[i]]
                    );
                }
                return ret;
            },

            isPast: function(date, checkOnlyDates) {
                if (checkOnlyDates) {
                    return _self.compareRange(null, date).isPast;
                } else {
                    var now = _self.createVenueDate();
                    return now.getTime() > date.getTime();
                }
            },
            getHourDifference: function(date1, date2) {
                var time1 = date1.getTime();
                var time2 = date2.getTime();
                var diff  = (time2 - time1) / 1000;
                if (diff < 0) {
                    diff = (diff * -1);
                }
                return ((diff / _self.SECONDS_IN_HOUR)-1);
            },
            /**
             * Calculates date difference in days between two given dates.
             *
             * @param Date date1
             * @param Date date2
             *
             * @return int Can be negative, if date2 ir greater
             */
            getDayDifference: function(date1, date2) {
                var time1 = date1.getTime();
                var time2 = date2.getTime();
                var diff  = (time1 - time2) / 1000;

                return Math.floor(diff / _self.SECONDS_IN_DAY);
            },

            /**
             * Return the first day of week for this venue, 0 being sunday.
             *
             * @return int
             */
            venueFirstDayOfWeek: function() {
                return _self.dayStringToNumberMap[App.config.get('dateFormat').firstDayOfWeek];
            },

            /**
             * Get a date range which spans over one full week.
             *
             * This means that if today is not the start of the week, the range will be from today till next week`s last
             * day.
             *
             * @param Date startFrom
             * @return Object { from: Date, to: Date }
             */
            getFullWeekRange: function(startFrom) {
                var firstDay   = _self.venueFirstDayOfWeek();
                var currentDay = startFrom.getDay();
                var addDays    = 7;

                if (currentDay === firstDay) {
                    addDays = 6;
                } else if (currentDay > firstDay) {
                    addDays += firstDay + 6 - currentDay;
                } else {
                    addDays += firstDay - currentDay - 1;
                }

                return {
                    from: _self.getMidnight(startFrom),
                    to  : new Date(
                        startFrom.getFullYear(),
                        startFrom.getMonth(),
                        startFrom.getDate() + addDays,
                        23,
                        59,
                        59
                    )
                };
            },

            /**
             * Returns array of each day in the given date range.
             *
             * @param Date from
             * @param Date to
             * @return Array
             */
            getRangeDays: function(from, to) {
                var days = [];

                from = _self.getMidnight(from);
                to   = _self.getMidnight(to);

                if (from.getTime() >= to.getTime()) {
                    return days;
                }

                while(!_self.isEqualDates(from, to)) {
                    days.push(from);
                    from = new Date(
                        from.getFullYear(),
                        from.getMonth(),
                        from.getDate() + 1,
                        0, 0, 0
                    );
                }
                days.push(to);

                return days;
            },

            /**
             * Returns day range from startDate to dateDate + days.
             *
             * @param Date startDate (optional) Defaults to now
             * @param int  days Days to add
             * @param Object options (optional)
             *   > asString: return the results as YYYY-MM-DD string
             *
             * @return Object { from, to }
             */
            getDayRange: function(startDate, days, options) {
                if (!_self.isValidDate(startDate)) {
                    startDate = new Date();
                }
                // Creating a new date object so that the passed in one would not be
                // altered.
                var tmpDate = _self.getMidnight( startDate );

                var result = {};
                result.from = new Date(tmpDate);

                tmpDate.setDate( tmpDate.getDate() + days );
                result.to = tmpDate;

                if (options && options.asString) {
                    result.from = _self.toApiString(result.from);
                    result.to   = _self.toApiString(result.to);
                }
                return result;
            },

            /**
             * Returns "today", "tomorrow" or a string formatted date.
             *
             * @param Object options
             * > Date   date       The date to calculate distance to
             * > String dateFormat (optional) Format of date to use if the date is not today nor tomorrow
             * > Date   now        (optional) The date to use as the current date (starting point)
             *
             * @return String
             */
            getDistanceInWordsOrDate: function(options) {
                options    = (options || {});
                var now    = _self.getMidnight(options.now || _self.createVenueDate());
                var date   = _self.getMidnight(options.date);
                var format = options.dateFormat || App.config.get('dateFormat').defaultDate;

                if (_self.isEqualDates(date, now)) {
                    return Wahanda.lang.date.today;
                } else if (1 === _self.getDayDifference(date, now)) {
                    return Wahanda.lang.date.tomorrow;
                }
                return _self.formatDate(format, date);
            },

            /**
             * Returns the closest weekday in the future.
             *
             * @param Date date
             * @param Int weekDay 0 .. 6
             *
             * @return Date or null, if the passed in parameters are incorrect
             */
            getNextWeekDay: function(date, weekDay) {
                if (!date instanceof Date || isNaN(weekDay)) {
                    return null;
                }

                var cDay = date.getDay();
                var diff = (weekDay - cDay) % 7;
                if (diff <= 0) {
                    diff += 7;
                }

                return new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate() + diff,
                    0, 0, 0
                );
            },

            previousWeekdayNumber: function(day) {
                if (day === 0) {
                    day = 7;
                }
                return day - 1;
            },

            setTime: function(date, hours, minutes) {
                return new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    hours,
                    minutes
                );
            },

            monthDays: function(date) {
                var d = new Date(date.getFullYear(), date.getMonth()+1, 0);
                return d.getDate();
            },

            getLastDayOfMonth: function(date, opts) {
                var opts = opts || {};
                var h = 0, m = 0, s = 0;

                if (opts.maxTime) {
                    h = 23;
                    m = s = 59;
                }

                return new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    _self.monthDays(date),
                    h, m, s
                );
            },

            isSameMonth: function(date1, date2) {
                return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
            },

            /**
             * Get the smallest of the dates.
             *
             * @param Date * Any number of dates.
             * @return Date
             */
            min: function() {
                var min = null;
                var date;
                for (var i = 0; date = arguments[i]; i++) {
                    if (_self.isValidDate(date) && (!min || min.getTime() > date.getTime())) {
                        min = date;
                    }
                }
                return date;
            },

            /**
             * Get the largest of the dates.
             *
             * @param Date * Any number of dates.
             * @return Date
             */
            max: function() {
                var max = null;
                var date;
                for (var i = 0; date = arguments[i]; i++) {
                    if (_self.isValidDate(date) && (!max || max.getTime() < date.getTime())) {
                        max = date;
                    }
                }
                return date;
            }
        };

        return _self;
    }
);
